import type { OptionGroup } from "@workspace/product-catalog-types";

interface Assignment {
	productId: string;
	optionGroupId: string;
}

/**
 * HA-599 AC4 — a product's option groups, in the order its Options tab set them in (the order the server
 * keeps the assignments). The library's own order is no longer applied on top, or a reorder on one product
 * would be undone at the till.
 */
export function optionGroupsByProduct(
	assignments: Assignment[],
	groups: OptionGroup[],
): Record<string, OptionGroup[]> {
	const byId = new Map(groups.map((g) => [g.id, g]));
	const map: Record<string, OptionGroup[]> = {};

	for (const assignment of assignments) {
		const group = byId.get(assignment.optionGroupId);
		if (!group) continue;
		(map[assignment.productId] ??= []).push(group);
	}

	return map;
}
